<template>
  <div class="stock-invoice-sources">
    <v-subheader class="px-0">{{ $t("STOCK.INVOICES.SOURCES") }}</v-subheader>
    <p class="caption grey--text text--darken-1 mb-4">
      {{ $t("STOCK.INVOICES.SOURCES_HINT") }}
    </p>

    <div v-if="actions.length" class="stock-invoice-sources__chips">
      <div
        v-for="action in actions"
        :key="action.id"
        class="stock-invoice-sources__item d-inline-flex align-center"
      >
        <router-link
          :to="actionRoute(action)"
          class="stock-invoice-sources__link"
        >
          <v-chip
            class="stock-invoice-sources__chip ma-1"
            :color="chipColor(action)"
            outlined
            label
          >
            <v-icon left small>{{ actionIcon(action) }}</v-icon>
            <span class="font-weight-medium">{{ action.code }}</span>
            <span v-if="action.action_type" class="ml-2 caption">
              {{ action.action_type.name }}
            </span>
          </v-chip>
        </router-link>
        <v-btn
          v-if="removable"
          icon
          x-small
          color="error"
          class="ml-1"
          :loading="removingActionId === action.id"
          @click="$emit('remove', action)"
        >
          <v-icon small>mdi-link-off</v-icon>
        </v-btn>
      </div>
    </div>

    <v-alert v-else type="info" dense outlined class="mt-2">
      {{ $t("STOCK.INVOICES.NO_SOURCES") }}
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "StockInvoiceSourcesPanel",
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
    removable: {
      type: Boolean,
      default: false,
    },
    removingActionId: {
      type: [Number, String],
      default: null,
    },
  },
  methods: {
    actionRoute(action) {
      const slug = action.action_type && action.action_type.slug;
      const category = action.action_type && action.action_type.category;
      if (category === "sale" || (slug && slug.startsWith("sale_"))) {
        return { name: "stock-sales-view", params: { id: action.id } };
      }
      if (category === "write_off" || slug === "write_off") {
        return { name: "stock-write-offs-view", params: { id: action.id } };
      }
      if (category === "transfer" || (slug && slug.startsWith("transfer_"))) {
        return { name: "stock-transfers-view", params: { id: action.id } };
      }
      return { name: "stock-receipts-view", params: { id: action.id } };
    },
    actionIcon(action) {
      const slug = action.action_type && action.action_type.slug;
      if (slug && slug.startsWith("sale_")) {
        return "mdi-truck-delivery-outline";
      }
      if (slug === "write_off") {
        return "mdi-delete-forever-outline";
      }
      if (slug && slug.startsWith("transfer_")) {
        return "mdi-swap-horizontal";
      }
      return "mdi-package-variant-closed";
    },
    chipColor(action) {
      const slug = action.action_type && action.action_type.slug;
      if (slug && slug.startsWith("sale_")) {
        return "primary";
      }
      return "teal";
    },
  },
};
</script>

<style scoped>
.stock-invoice-sources__link {
  text-decoration: none;
}
.stock-invoice-sources__chip {
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.stock-invoice-sources__chip:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}
.stock-invoice-sources__item {
  vertical-align: middle;
}
</style>
